/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfigSearchRequestModel } from '../../models/config-search-request-model';
import { TermsConditionsModel } from '../../models/terms-conditions-model';

export interface AnonymousTermsConditionsPost$Params {
      body?: ConfigSearchRequestModel
}

export function anonymousTermsConditionsPost(http: HttpClient, rootUrl: string, params?: AnonymousTermsConditionsPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<TermsConditionsModel>>> {
  const rb = new RequestBuilder(rootUrl, anonymousTermsConditionsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<TermsConditionsModel>>;
    })
  );
}

anonymousTermsConditionsPost.PATH = '/Anonymous/TermsConditions';
